import * as React from 'react'

export default class extends React.Component<any, any>{


    render(){
        const className = "col-12 mb-4 step-block" + (this.props.className ? " " + this.props.className : "" )
        if(this.props.show ==null || this.props.show == true){
            return(
                <div className={ className }>
                    { this.props.children }
                </div>
            )
        }else{
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/step-block.tsx